/**
 * @fileoverview 安灯管理模块枚举定义
 * 
 * 对应后端文件：
 * - backend/app/Modules/Andon/Models/AndonDevice.php
 * - backend/app/Modules/Andon/Models/AndonCall.php
 * - backend/app/Modules/Andon/Models/AndonCallType.php
 * 
 * @last-updated 2025-11-05
 */

/**
 * 安灯类型枚举
 */
export enum AndonType {
  /** 按钮式 */
  BUTTON = 'BUTTON',
  /** 拉绳式 */
  ROPE = 'ROPE',
  /** 触摸屏 */
  TOUCH = 'TOUCH',
  /** 灯柱 */
  TOWER = 'TOWER',
}

/**
 * 通信协议枚举
 */
export enum AndonProtocol {
  /** HTTP协议 */
  HTTP = 'HTTP',
  /** MQTT协议 */
  MQTT = 'MQTT',
  /** TCP协议 */
  TCP = 'TCP',
  /** Modbus协议 */
  MODBUS = 'MODBUS',
}

/**
 * 呼叫类型枚举
 */
export enum AndonCallType {
  /** 质量异常 */
  QUALITY = 'QUALITY',
  /** 设备故障 */
  EQUIPMENT = 'EQUIPMENT',
  /** 物料短缺 */
  MATERIAL = 'MATERIAL',
  /** 换型 */
  PROCESS = 'PROCESS',
  /** 安全事故 */
  SAFETY = 'SAFETY',
  /** 其他异常 */
  OTHER = 'OTHER',
}

/**
 * OEE 六大损失类型
 *
 * 呼叫类型开放自定义后，用于类型配置中选择 OEE 停机损失归类。
 */
export enum AndonLossType {
  /** 设备故障 */
  BREAKDOWN = 1,
  /** 换型调整 */
  SETUP = 2,
  /** 空转短停 */
  IDLING = 3,
  /** 速度降低 */
  REDUCED_SPEED = 4,
  /** 启动废品 */
  STARTUP_REJECT = 5,
  /** 生产废品 */
  PRODUCTION_REJECT = 6,
}

/**
 * 呼叫状态枚举
 */
export enum AndonCallStatus {
  /** 待响应 */
  PENDING = 'PENDING',
  /** 已响应 */
  RESPONDED = 'RESPONDED',
  /** 已完成 */
  COMPLETED = 'COMPLETED',
  /** 已取消 */
  CANCELLED = 'CANCELLED',
}

/**
 * 呼叫优先级枚举
 */
export enum AndonPriority {
  /** 低 */
  LOW = 1,
  /** 中 */
  MEDIUM = 2,
  /** 高 */
  HIGH = 3,
  /** 紧急 */
  URGENT = 4,
}

/**
 * 工位状态枚举（实时面板）
 */
export enum WorkstationMapStatus {
  /** 正常 */
  NORMAL = 'NORMAL',
  /** 呼叫中 */
  ALERT = 'ALERT',
  /** 响应中 */
  RESPONDED = 'RESPONDED',
}

